export const FbtAiData = [
    {
        id: "gid://shopify/Product/9776940384578",
        images: [
            {
                id: "gid://shopify/ProductImage/47453219815746",
                altText: "black",
                originalSrc: "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/images.jpg?v=1730700141",
            },
        ],
        title: "black-semi casual",
        selectedVariants: [
            {
                price: "800.0",
                required_product: false,
                compareAtPrice: "800.0",
                displayName: "black-semi casual",
                id: "gid://shopify/ProductVariant/49962792157506",
                selectedOptions: [
                    {
                        name: "Title",
                        value: "Default Title",
                    },
                ],
                title: "black-semi casual",
                image: {
                    originalSrc: "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/images.jpg?v=1730700141",
                },
                quantityAvailable: 32,
                availableForSale: true,
                selling_plan: "",
                copyPrice: "800.0",
                productIdx: 2,
            },
        ],
        quantity: 1,
        variants: [
            {
                price: "800.0",
                required_product: false,
                compareAtPrice: "800.0",
                displayName: "black-semi casual",
                id: "gid://shopify/ProductVariant/49962792157506",
                selectedOptions: [
                    {
                        name: "Title",
                        value: "Default Title",
                    },
                ],
                title: "black-semi casual",
                image: {
                    originalSrc: "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/images.jpg?v=1730700141",
                },
                quantityAvailable: 32,
                availableForSale: true,
            },
        ],
    },
    {
        id: "gid://shopify/Product/9776939499842",
        images: [
            {
                id: "gid://shopify/ProductImage/47453214671170",
                originalSrc: "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/campstool-1.jpg?v=1730700022",
            },
        ],
        title: "Camp Stool",
        selectedVariants: [
            {
                price: "78.0",
                required_product: false,
                compareAtPrice: "78.0",
                displayName: "Camp Stool",
                id: "gid://shopify/ProductVariant/49962788749634",
                selectedOptions: [
                    {
                        name: "Title",
                        value: "Camp Stool",
                    },
                ],
                title: "Camp Stool",
                image: {
                    originalSrc: "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/campstool-1.jpg?v=1730700022",
                },
                quantityAvailable: 1100,
                availableForSale: true,
                selling_plan: "",
                copyPrice: "78.0",
                productIdx: 3,
            },
        ],
        quantity: 1,
        variants: [
            {
                price: "78.0",
                required_product: false,
                compareAtPrice: "78.0",
                displayName: "Camp Stool",
                id: "gid://shopify/ProductVariant/49962788749634",
                selectedOptions: [
                    {
                        name: "Title",
                        value: "Camp Stool",
                    },
                ],
                title: "Camp Stool",
                image: {
                    originalSrc: "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/campstool-1.jpg?v=1730700022",
                },
                quantityAvailable: 1100,
                availableForSale: true,
            },
        ],
    },
    {
        id: "gid://shopify/Product/9776939794754",
        images: [
            {
                id: "gid://shopify/ProductImage/47453216899394",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/Lunchbag_Khaki_Front_8ae0e1f4-407d-4ac0-89e6-961b306ef351.jpg?v=1730700068",
            },
            {
                id: "gid://shopify/ProductImage/47453216932162",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/Lunchbag_Moss_Front_c5dfe951-8bdc-4fff-8c8a-9a87cc02736d.jpg?v=1730700068",
            },
        ],
        title: "Canvas Lunch Bag",
        selectedVariants: [
            {
                price: "32.0",
                required_product: false,
                compareAtPrice: "32.0",
                displayName: "Khaki",
                id: "gid://shopify/ProductVariant/49962790158658",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Khaki",
                    },
                ],
                title: "Khaki",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/Lunchbag_Khaki_Front_8ae0e1f4-407d-4ac0-89e6-961b306ef351.jpg?v=1730700068",
                },
                quantityAvailable: 30,
                availableForSale: true,
                selling_plan: "",
                copyPrice: "32.0",
                productIdx: 4,
            },
        ],
        quantity: 1,
        variants: [
            {
                price: "32.0",
                required_product: false,
                compareAtPrice: "32.0",
                displayName: "Khaki",
                id: "gid://shopify/ProductVariant/49962790158658",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Khaki",
                    },
                ],
                title: "Khaki",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/Lunchbag_Khaki_Front_8ae0e1f4-407d-4ac0-89e6-961b306ef351.jpg?v=1730700068",
                },
                quantityAvailable: 30,
                availableForSale: true,
            },
        ],
    },

    {
        id: "gid://shopify/Product/9776939958594",
        images: [
            {
                id: "gid://shopify/ProductImage/47453217947970",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/chevron_cream_542f1c3e-e0d9-4c94-aaa2-fff0d1368206.jpg?v=1730700087",
            },
        ],
        title: "Chevron",
        selectedVariants: [
            {
                price: "36.0",
                required_product: false,
                compareAtPrice: "36.0",
                displayName: "Cream Melange / XS",
                id: "gid://shopify/ProductVariant/49962790781250",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Cream Melange",
                    },
                    {
                        name: "Size",
                        value: "XS",
                    },
                ],
                title: "Cream Melange / XS",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/chevron_cream_542f1c3e-e0d9-4c94-aaa2-fff0d1368206.jpg?v=1730700087",
                },
                quantityAvailable: 10,
                availableForSale: true,
                selling_plan: "",
                copyPrice: "36.0",
                productIdx: 6,
            },
        ],
        quantity: 1,
        variants: [
            {
                price: "36.0",
                required_product: false,
                compareAtPrice: "36.0",
                displayName: "Cream Melange / XS",
                id: "gid://shopify/ProductVariant/49962790781250",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Cream Melange",
                    },
                    {
                        name: "Size",
                        value: "XS",
                    },
                ],
                title: "Cream Melange / XS",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/chevron_cream_542f1c3e-e0d9-4c94-aaa2-fff0d1368206.jpg?v=1730700087",
                },
                quantityAvailable: 10,
                availableForSale: true,
            },
        ],
    },
    {
        id: "gid://shopify/Product/9776939827522",
        images: [
            {
                id: "gid://shopify/ProductImage/47453217259842",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/DawsonTrolley_Moss_Front_6cca3dc3-51d3-4205-a1e1-ed5d9a03e181.jpg?v=1730700074",
            },
            {
                id: "gid://shopify/ProductImage/47453217292610",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/DawsonTrolley_Moss_HandleOpen_14842a9b-7222-4ce2-9d17-4731d23454a7.jpg?v=1730700074",
            },
            {
                id: "gid://shopify/ProductImage/47453217325378",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/product_lifestyle-9.jpg?v=1730700074",
            },
        ],
        title: "Dawson Trolley",
        selectedVariants: [
            {
                price: "278.0",
                required_product: false,
                compareAtPrice: "278.0",
                displayName: "Moss",
                id: "gid://shopify/ProductVariant/49962790256962",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Moss",
                    },
                ],
                title: "Moss",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/DawsonTrolley_Moss_Front_6cca3dc3-51d3-4205-a1e1-ed5d9a03e181.jpg?v=1730700074",
                },
                quantityAvailable: 10,
                availableForSale: true,
                selling_plan: "",
                copyPrice: "278.0",
                productIdx: 8,
            },
        ],
        quantity: 1,
        variants: [
            {
                price: "278.0",
                required_product: false,
                compareAtPrice: "278.0",
                displayName: "Moss",
                id: "gid://shopify/ProductVariant/49962790256962",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Moss",
                    },
                ],
                title: "Moss",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/DawsonTrolley_Moss_Front_6cca3dc3-51d3-4205-a1e1-ed5d9a03e181.jpg?v=1730700074",
                },
                quantityAvailable: 10,
                availableForSale: true,
            },
        ],
    },
    {
        id: "gid://shopify/Product/9776939991362",
        images: [
            {
                id: "gid://shopify/ProductImage/47453217980738",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/derbytier_nutmeg_810294de-9152-4bf7-b5e0-b88fc94a1ff8.jpg?v=1730700093",
            },
            {
                id: "gid://shopify/ProductImage/47453218013506",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/derbytier_moss_drawstring.jpg?v=1730700093",
            },
            {
                id: "gid://shopify/ProductImage/47453218046274",
                originalSrc:
                    "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/product_lifestyle-58.jpg?v=1730700093",
            },
        ],
        title: "Derby Tier Backpack",
        selectedVariants: [
            {
                price: "148.0",
                required_product: false,
                compareAtPrice: "165.0",
                displayName: "Nutmeg",
                id: "gid://shopify/ProductVariant/49962790945090",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Nutmeg",
                    },
                ],
                title: "Nutmeg",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/derbytier_nutmeg_810294de-9152-4bf7-b5e0-b88fc94a1ff8.jpg?v=1730700093",
                },
                quantityAvailable: 100,
                availableForSale: true,
                selling_plan: "",
                copyPrice: "148.0",
                productIdx: 9,
            },
        ],
        quantity: 1,
        variants: [
            {
                price: "148.0",
                required_product: false,
                compareAtPrice: "165.0",
                displayName: "Nutmeg",
                id: "gid://shopify/ProductVariant/49962790945090",
                selectedOptions: [
                    {
                        name: "Color",
                        value: "Nutmeg",
                    },
                ],
                title: "Nutmeg",
                image: {
                    originalSrc:
                        "https://cdn.shopify.com/s/files/1/0879/0428/9090/files/derbytier_nutmeg_810294de-9152-4bf7-b5e0-b88fc94a1ff8.jpg?v=1730700093",
                },
                quantityAvailable: 100,
                availableForSale: true,
            },
        ],
    },
];

console._log("asdfasdfsafdads", FbtAiData.length);
